import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DashboardPopup from '../DashboardPopup'
import Button from 'components/UI/Button/Button'
import {
  Title,
  StyledForm,
  StyledFormInput,
  ButtonRow,
  Footnote,
  Link
} from './SensitiveInfoPopup.styles'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'

export default class SensitiveInfoPopup extends Component {
  render () {
    return (
      <DashboardPopup
        onCancel={this.props.onCancel}
        isSettings
      >
        <Title>
          You are changing sensitive information
        </Title>
        {
          this.props.passwordError
            ? (
              <Footnote color={colors.red}>
              Incorrect password - please try again
              </Footnote>
            )
            : (
              <Footnote color={colors.darkTeal}>
                {`Please enter your ${this.props.isChangingPassword ? 'old' : ''} password`}
              </Footnote>
            )
        }

        <StyledForm id='password-popup' onValidSubmit={this.props.onConfirm}>
          <StyledFormInput
            placeholderColor={colors.grey}
            focusColor={colors.orange}
            backgroundFocusColor={colors.lightOrange}
            element={'button'}
            narrow
            width='140px'
            textSize='15px'
            fieldNameSize='18px'
            onChange={this.onInputChange}
            name='password'
            placeholder='Password'
            type='password'
            required
          />
        </StyledForm>
        <ButtonRow>
          <Button
            element='button'
            type='submit'
            form='password-popup'
            bgColor={colors.grassGreen}
            color='white'
            size='regular'
          >
            Submit
          </Button>
          <Button
            bgColor={colors.red}
            color='white'
            size='regular'
            onClick={this.props.onCancel}
          >
            Cancel
          </Button>
        </ButtonRow>
        <Link href='https://www.nightzookeeper.com/edu/forgot-password' target='_blank'>{`Forgot your ${this.props.isChangingPassword ? 'old' : ''} password?`}</Link>
      </DashboardPopup>
    )
  }
}
